import React, { useState, useEffect, FC } from 'react';
import { Modal, Button } from '@tencent/tea-component';
import style from './index.module.scss';
import UploadBox from './upload';

const HeadUpload: FC<IProps> = (props: IProps) => {
  const { visible, onConfrim, onCancel, defaultHeadUrl } = props;
  const [show, setShow] = useState(visible);
  const [headUrl, setHeadUrl] = useState('');
  const [cosId, setCodId] = useState('');

  useEffect(() => {
    setShow(visible);
    if (visible === false) {
      setHeadUrl('');
    }
  }, [visible]);

  // 上传完成回调
  const handleUploadComplete = (data: any) => {
    const { url, cosId } = data;
    setHeadUrl(url);
    setCodId(cosId);
  };

  const handleConfirm = () => {
    if (onConfrim)
      onConfrim({
        url: headUrl,
        cosId,
      });
  };

  const handleCancel = () => {
    if (onCancel) onCancel();
  };

  return (
    <>
      <Modal
        size={420}
        visible={show}
        className={style['head-modal']}
        caption="修改头像"
        maskStyle={{ background: '#0000004f' }}
        onClose={handleCancel}
      >
        <Modal.Body>
          <UploadBox
            defaultHeadUrl={defaultHeadUrl}
            onUploadComplete={handleUploadComplete}
            uploadMsg="推荐使用480px*480px尺寸，支持png/jpg/jpeg格式，大小不超过5M"
          ></UploadBox>
        </Modal.Body>
        <Modal.Footer>
          <Button disabled={headUrl === ''} type="primary" onClick={handleConfirm}>
            确定
          </Button>
          <Button type="weak" onClick={handleCancel}>
            取消
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

interface IProps {
  visible: boolean; // 打开关闭弹窗
  defaultHeadUrl: string; // 默认头像
  onConfrim: Function; // 确认回调
  onCancel?: Function; // 取消回调
}

export default HeadUpload;
